<template>
  <div id="app">
    <el-container>
      <el-header>
        <navbar></navbar>
      </el-header>
      <el-main>
        <scriptdetail :id="id"></scriptdetail>
      </el-main>
      <el-footer>
        <icp-footer></icp-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import navbar from "../../../components/navbar";
import scriptdetail from "../../../components/script/scriptdetail";
import icpFooter from "../../../components/icpFooter";
export default {
  components: {
    scriptdetail,
    navbar,
    icpFooter,
  },
  data() {
    return {
      
    };
  },

  methods: {},
  computed: {
    id: () => window.location.href.split("/").pop(),
  },
};
</script>

<style></style>
